import { useContext } from "react";
import { BootstrapperContext } from "../../../context/bootstrapperContext";
import { Feature } from "../../../context/types";

import logging from "../../../util/logging";
const log = logging("use feature toggle");

export function useFeatureToggles(feature: Feature): boolean {
  const { featureToggles } = useContext(BootstrapperContext);
  if (featureToggles && feature in featureToggles) {
    return featureToggles[feature];
  }

  log.warn("Feature toggle " + feature + " doesn't exist");

  return false;
}
